import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@mui/material';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import React, { useState } from 'react';
import { IConfig } from '../../../../../../../Interfaces/IConfig';
import { IPostcode } from '../../../../../../../Interfaces/IPostcode';
import { IRealEstate } from '../../../../../../../Interfaces/IRealEstate';
import PostcodeSearch from '../../../../../../generic/PostcodeSearch';
import { MapSearch } from '../../../../PurchaseContract/Components/RealEstate/MapSearch';

interface IProps {
  configObject: IConfig;
  currentObject: IRealEstate;
  setCurrentObject: Function;
  marginTop?: number;
}

export const MortgageRealEstateAddress: React.FC<IProps> = ({
  configObject,
  currentObject,
  setCurrentObject,
  marginTop,
}) => {
  const [mapValue, setMapValue] = useState<string | null>('false');
  const handlePostcode = (localObject: IRealEstate) => {
    if (
      localObject.idPostcode !== null &&
      localObject.idPostcode > 0 &&
      localObject.City !== undefined &&
      localObject.Postcode !== undefined
    ) {
      return {
        idPostcode: localObject.idPostcode,
        City: localObject.City,
        Postcode: localObject.Postcode,
        idCountry: 1,
      } as IPostcode;
    } else {
      return null;
    }
  };

  const setPostcodeObjectWrapper = (
    postcodeObject: IPostcode | null | undefined
  ) => {
    if (postcodeObject) {
      setCurrentObject({
        ...currentObject,
        idPostcode: postcodeObject.idPostcode,
        Postcode: postcodeObject.Postcode,
        City: postcodeObject.City,
      } as IRealEstate);
    }
    setPostcodeObject(postcodeObject);
  };

  const [postcodeObject, setPostcodeObject] = useState<
    IPostcode | null | undefined
  >(handlePostcode(currentObject));

  const handleToggle = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMapValue(event.target.value);
  };

  return (
    <>
      <Typography
        variant='h5'
        sx={{ mt: marginTop === undefined ? 2 : marginTop, mb: 2 }}
      >
        Anschrift des Objektes
      </Typography>
      <Typography mb={2}>
        Bitte geben Sie die Adresse des Objektes an.
      </Typography>
      <Grid container spacing={2}>
        <Grid item sm={5}>
          <TextField
            label='Straße'
            size='small'
            required
            fullWidth
            value={currentObject.Street === null ? '' : currentObject.Street}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                Street: event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={5}>
          <TextField
            label='Adresszusatz'
            size='small'
            fullWidth
            value={
              currentObject.StreetAditional === null
                ? ''
                : currentObject.StreetAditional
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                StreetAditional:
                  event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={2}>
          <TextField
            label='Hausnummer'
            size='small'
            required
            fullWidth
            value={
              currentObject.StreetNr === null ? '' : currentObject.StreetNr
            }
            onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
              setCurrentObject({
                ...currentObject,
                StreetNr: event.target.value === '' ? null : event.target.value,
              })
            }
          />
        </Grid>
        <Grid item sm={12}>
          <PostcodeSearch
            postcodeObject={postcodeObject}
            setPostcodeObject={setPostcodeObjectWrapper}
            required
          />
        </Grid>

        <Grid item sm={12}>
          <Box sx={{ mt: 1 }} />
        </Grid>

        <Grid item sm={12}>
          <Box sx={{ mt: 1 }} />
        </Grid>
        <Box ml={2} mt={2}>
          <Typography sx={{ mb: 2 }}>Karte anzeigen?</Typography>

          <FormControl component='fieldset'>
            <RadioGroup
              row
              aria-label='property-owned'
              name='property-owned'
              value={mapValue}
              onChange={handleToggle}
            >
              <FormControlLabel value='true' control={<Radio />} label='Ja' />
              <FormControlLabel
                value='false'
                control={<Radio />}
                label='Nein'
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {mapValue === 'true' && (
          <Grid item sm={12}>
            <Accordion>
              <AccordionSummary
                expandIcon={<GridExpandMoreIcon />}
                aria-controls='panel1a-content'
                id='panel1a-header'
              >
                <Typography>Adresse / Koordinaten suchen</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <MapSearch
                  configObject={configObject}
                  realEstate={currentObject}
                  setRealEstate={setCurrentObject}
                  setPostcodeObject={setPostcodeObject}
                />
              </AccordionDetails>
            </Accordion>
          </Grid>
        )}
      </Grid>
    </>
  );
};
